import * as React from 'react';
function IconPremium(props) {
    return (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-xds": "IconPremium", ...props },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.551 3L1.167 8.987l10.83 12.541.003.002L22.833 8.986 17.445 3H6.551zM9.03 5H7.443L4.744 8h3.242L9.03 5zm1.066 3h9.159l-2.7-3H11.14l-1.044 3zm9.219 2l-5.536 6.41L16.01 10h3.305zm-8.063 7.605L13.9 10H4.685l6.567 7.605z", fill: "currentColor" })));
}
export default IconPremium;
//# sourceMappingURL=IconPremium.js.map